import {
	Action,
	LOGIN_FAILED,
	LOGIN_REQUESTED,
	LOGIN_SUCCEEDED,
} from './actions';
import { LoginType, initialState } from './types';

// unnecessary to keep track of login
// can be combined with user setup...
export const reducer = (
	state: LoginType = initialState,
	action: Action
): LoginType => {
	switch (action.type) {
		case LOGIN_REQUESTED:
		case LOGIN_FAILED:
			return initialState;
		case LOGIN_SUCCEEDED:
			return {
				success: true,
				valid: true,
			};
		default:
			return state;
	}
};
